import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Radio } from 'rmwc/Radio';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'

class ResourceAndQuestionOfTheDay extends Component {

  constructor(props){
    super(props);
    this.state={
      showResourceOfTheDay: false,
      showQuestionOfTheDay: false
    }
    this.handleRendering = this.handleRendering.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount(){
    if (this.props.match.params.typeName === 'resource') {
      this.setState({showResourceOfTheDay: true})
    }
    else if (this.props.match.params.typeName === 'question'){
      this.setState({showQuestionOfTheDay: true})
    }
  }

  handleRendering(value) {
    console.log(value)
    if(value === 'resource'){
      this.setState({showResourceOfTheDay: true})
    }
    else if (value === 'question'){
      this.setState({showQuestionOfTheDay: true})
    }
    else if (value === 'questionOfTheDay'){
      //console.log('Inside question of the day')
      //this.props.history.push('/portal/app/admin/resource_and_question_of_the_day/question')
      this.setState({showQuestionOfTheDay: false, showResourceOfTheDay: false})
    }
    else if (value === 'resourceOfTheDay'){
      // this.props.history.push('/portal/app/admin/resource_and_question_of_the_day/resource')
      this.setState({showQuestionOfTheDay: false, showResourceOfTheDay: false})
    }
  }

  goBack() {
    this.setState({showResourceOfTheDay: false, showQuestionOfTheDay: false})
  }

  render() {
    let displayComponent;
    if (this.state.showResourceOfTheDay) {
      displayComponent = (<ResourceOfTheDay accessToken={this.props.user.accessToken} handleRefresh={this.handleRendering} goBack={this.goBack}/>)
    }
    else if (this.state.showQuestionOfTheDay) {
      displayComponent = (<QuestionOfTheDay accessToken={this.props.user.accessToken} handleRefresh={this.handleRendering} goBack={this.goBack}/>)
    }
    else {
      displayComponent = (<div>
          <Typography use="headline6" onClick={() => this.handleRendering("resource")} style={{color: 'blue',textDecorationLine: 'underline'}}>Resource of the Day</Typography>
          <br/><br/>
          <Typography use="headline6" onClick={() => this.handleRendering("question")} style={{color: 'blue',textDecorationLine: 'underline'}}>Question of the Day</Typography>
        </div>
      )
    }

    return(
      <div>
        <Grid>
          <GridCell span="12">
            <Card style={{padding: '25px'}}>
              <GridCell span="12">
                <Typography use="headline6">Resource and Questionnaire of the day</Typography>
              </GridCell>
              <hr/>
              {displayComponent}
            </Card>
          </GridCell>
        </Grid>
      </div>
      );
  }
}

class ResourceOfTheDay extends Component {
  constructor(props) {
    super(props);
    this.state={
      resourceId: '',
      resourceLink: '',
      checkMsg: '',
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {

    return api.getResourceOfTheDay(this.props.accessToken)
    .then((result) => {
      this.setState({
        resourceId: result[0].value,
        resourceLink: result[1].value
      })
    })
  }

  onInputChange = evt => {
    this.setState({[evt.target.name]: evt.target.value})
  };

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.resourceId === ''){
      this.setState({checkMsg: 'Please fill the Resource Id'})
      return
    }
    if(this.state.resourceLink === ''){
      this.setState({checkMsg: 'Please fill the Resource Link'})
      return
    }
    let  values = {
        'resource_id': this.state.resourceId,
        'resource_link': this.state.resourceLink
      }
    api.updateResourceOfTheDay(this.props.accessToken, values)
        .then((result) => {
          if(result.status === 'success'){
            this.setState({checkMsg: 'Updated Successfully'})
            this.props.handleRefresh("resourceOfTheDay")
          }
          else{
            this.setState({checkMsg: 'Update Failed'})
          }
        })
  }

  render() {
    return(
      <div>
        <Grid>
          <GridCell span="10">
            <Typography use="headline6">Resource of the day</Typography>
          </GridCell>
          <GridCell span="2">
            <Button onClick={this.props.goBack}>Back</Button>
          </GridCell>
          <GridCell span="12">
            <form onSubmit={this.handleSubmit}>
              <GridCell span="12">
                <TextField fullwidth label="Resource Id" autoComplete="off" name="resourceId" onChange={this.onInputChange} value={this.state.resourceId} style={{ height: '140%' }}/>
              </GridCell>
              <GridCell span="12">
                <TextField fullwidth label="Resource Image Link" autoComplete="off" name="resourceLink" onChange={this.onInputChange} value={this.state.resourceLink} style={{ height: '140%' }}/>
              </GridCell>
              <br/>
              <Button raised>Update</Button>
            </form>
            {this.state.checkMsg}
          </GridCell>
        </Grid>
      </div>
    );
  }
}

class QuestionOfTheDay extends Component {
  constructor(props) {
    super(props);
    this.state={
      questionnaireName: '',
      enableSpecificDisplay: '',
      checkMsg: '',
      questionId: '',
      showEnableComponent: false,
      newQuestionnaireName: '',
      customId: '',
      questionnaireLink: '',
      questionLink: '',
    }
    this.updateSpecificDisplay = this.updateSpecificDisplay.bind(this);
    this.submitQuestionOfTheDay = this.submitQuestionOfTheDay.bind(this);
  }

  componentDidMount() {

    return api.getQuestionOfTheDay(this.props.accessToken)
    .then((result) => {
      if(result.status === 'success') {
        this.setState({
          enableSpecificDisplay: result.data.specific_display,
          questionnaireName: result.data.name,
          questionId: result.data.id,
          questionLink: result.data.questionnaire_link,
        })
      }
      else{
        this.setState({
          showEnableComponent: true,
        })
      }
    })
  }

  onInputChange = evt => {
    this.setState({[evt.target.name]: evt.target.value})
  };

  onRadioButtonChange = evt => {
    console.log(evt.target.value)
    if(evt.target.value === "0") {
    this.setState({[evt.target.name]: 0})
    }
    else if(evt.target.value === "1") {
      this.setState({[evt.target.name]: 1})
    }
  };

  updateSpecificDisplay(e) {
    e.preventDefault();
    let  values = {
        'question_id': this.state.questionId,
        'specific_display': this.state.enableSpecificDisplay
      }
    api.updateSpecificDisplay(this.props.accessToken, values)
      .then((result) => {
        if(result.status === 'success'){
          this.setState({checkMsg: 'Updated Successfully'})
          this.props.handleRefresh("questionOfTheDay")
        }
        else{
          this.setState({checkMsg: result.data})
        }
      })
  }

  submitQuestionOfTheDay(e) {
    e.preventDefault();
    if(this.state.newQuestionnaireName === '') {
      this.setState({checkMsg: 'Please fill the  Questionnaire name'})
      return
    }
    if(this.state.customId === '') {
      this.setState({checkMsg: 'Please fill the  Custom ID'})
      return
    }
    if(this.state.questionnaireLink === '') {
      this.setState({checkMsg: 'Please fill the Questionnaire Link'})
      return
    }

    let  values = {
        'name': this.state.newQuestionnaireName,
        'custom_id': this.state.customId,
        'questionnaire_link': this.state.questionnaireLink,
        'global_type_id': '4',
        'specific_display': '1',
      }
    api.postQuestionOfTheDay(this.props.accessToken, values)
      .then((result) => {
        if(result.status === 'success'){
          this.setState({checkMsg: 'Updated Successfully'})
          this.props.handleRefresh("questionOfTheDay")
        }
        else{
          this.setState({checkMsg: result.data})
        }
      })
  }

  render() {
    let enableDisplayComponent;
    if(this.state.showEnableComponent){
      enableDisplayComponent = ('');
    }
    else {
      enableDisplayComponent = (<div><hr/>
          <Typography use="headline6">Currently Active Questionnaire</Typography>
          <br/><br/>
          <Typography use="subtitle">Name: {this.state.questionnaireName}</Typography>
          <br/><br/>
          <Typography use="subtitle">Link: {this.state.questionLink}</Typography>
          <br/><br/>
          <Radio name="enableSpecificDisplay" value="1" checked={this.state.enableSpecificDisplay === 1} onChange={this.onRadioButtonChange}>
            Yes
          </Radio>
          <Radio name="enableSpecificDisplay" value="0" checked={this.state.enableSpecificDisplay === 0} onChange={this.onRadioButtonChange}>
            No
          </Radio>
          <br/>
          <Button  onClick={this.updateSpecificDisplay}>Update</Button>
        </div>
      )
    }
    return(
      <div>
        <Grid>
          <GridCell span="10">
            <Typography use="headline6">Questionnaire of the day</Typography>
          </GridCell>
          <GridCell span="2">
            <Button onClick={this.props.goBack}>Back</Button>
          </GridCell>
        </Grid>
        <GridCell span="12">
          {enableDisplayComponent}
        </GridCell>
        <br/>
        <hr/>
        <GridCell span="12">
          <Grid>
            <GridCell span="12">
              <Typography use="headline6">New Questionnaire Addition</Typography>
            </GridCell>
            <GridCell span="12">
              <TextField fullwidth label="Name" autoComplete="off" name="newQuestionnaireName" onChange={this.onInputChange} value={this.state.newQuestionnaireName} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="12">
              <TextField fullwidth label="Questionnaire Link" autoComplete="off" name="questionnaireLink" onChange={this.onInputChange} value={this.state.questionnaireLink} style={{ height: '140%' }}/>
            </GridCell>
            <GridCell span="12">
              <TextField fullwidth label="Custom Id" autoComplete="off" name="customId" onChange={this.onInputChange} value={this.state.customId} style={{ height: '140%' }}/>
            </GridCell>
          </Grid>
          <br/>
          <Button raised onClick={this.submitQuestionOfTheDay}>Update</Button>
          <StatusMessage error_msg = {this.state.checkMsg}/>
        </GridCell>
      </div>
    );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceAndQuestionOfTheDay);


// WEBPACK FOOTER //
// ./src/views/admin/ResourceAndQuestionOfTheDay.jsx